// GENERATED by scripts/gen-web-routes.mjs — regenerate after frontend/app/ changes.
import { createFileRoute } from "@tanstack/react-router"
import Page from "@/app/dealer-analytics/new-dealer/page"
import { usePageHead } from "../../../compat/head"

export const Route = createFileRoute("/dealer-analytics/new-dealer/")({
  component: PageComponent,

})

function PageComponent() {
  return <Page />
}
